import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function ScopeBanner() {
  return (
    <section
      data-testid="scope-banner-section"
      className="bg-[#2B2420] text-white py-16 md:py-20 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(201,162,76,0.22),transparent_55%)]" aria-hidden />
      <div className="relative px-6 md:px-10 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#C9A24C] mb-4">
            Flexible scope
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-black tracking-tighter leading-[0.95] text-3xl sm:text-4xl md:text-5xl lg:text-[56px] text-white"
            style={{ fontFamily: "Cabinet Grotesk" }}
          >
            Small jobs welcome. <br /> Full projects, even better.
          </motion.h2>
          <p className="mt-5 max-w-xl text-white/80 text-base md:text-lg">
            A single repair, a whole flat, or a multi-floor commercial
            refurbishment — we scale to your project, not the other way round.
          </p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <a
            href="#quote"
            data-testid="scope-banner-cta"
            className="inline-flex items-center gap-2 bg-[#C9A24C] hover:bg-[#B08C3F] text-[#2B2420] px-7 py-5 text-sm font-bold uppercase tracking-[0.15em] transition-colors"
          >
            Request a Free Quote <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
